import React, { useContext, useRef, useEffect, useState } from "react"
import propTypes from "prop-types"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import AddContact from "components/OldContacts/ContactTable/addContact"
import AuthContext from "context/auth/authContext"
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp"
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp"
import TeamsContext from "context/teams/teamsContext"
import { useParams } from "react-router-dom"
import i18n from "i18n"
import { ROLE_OPTIONS } from "./constants/roles"

const UserEditModal = ({ open, setOpen, worker }) => {
  const { projectId } = useParams()
  const [openAdd, setOpenAdd] = useState(false)
  const [cambiado, setCambiado] = useState(false)
  const [selectedRol, setSelectedRol] = useState("")
  const { user, freeTrialExpired } = useContext(AuthContext)
  const { updateWorkerCampos, getWorkersByProject, deleteWorker } =
    useContext(TeamsContext)
  useEffect(() => {
    if (cambiado == true) {
      setOpen(false)
    }
  }, [cambiado])

  useEffect(() => {
    if (worker != null) {
      setSelectedRol(worker.customRole?.value || "")
      setMail(worker.email)
    }
  }, [worker])

  const [mail, setMail] = useState("")

  const handleChangeMail = e => {
    setMail(e.target.value)
  }
  const [validaMail, setValidaMail] = useState(false)
  const refEmail = useRef(null)
  const refEmailConfirm = useRef(null)
  const refEmailError = useRef(null)

  const valida = e => {
    if (e.target.name == "mail") {
      if (emailIsValid(mail)) {
        setValidaMail(true)
        refEmail.current.id = " "
        refEmailConfirm.current.id = "confirmVisible"
        refEmailError.current.id = "errorNotVisible"
      } else {
        refEmail.current.id = "errorValidation"
        setValidaMail(false)
        refEmailError.current.id = "errorVisible"
        refEmailConfirm.current.id = "confirmNotVisible"
      }
    }
  }
  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const [loading, setLoading] = useState(false)
  const handleUpdate = async e => {
    e.preventDefault()
    if (mail != "" && emailIsValid(mail)) {
      const roleConfig = ROLE_OPTIONS.find(role => role.value === selectedRol)
      const customRole = roleConfig
        ? {
            color: roleConfig.color,
            value: roleConfig.value,
            bgColor: roleConfig.bgColor,
          }
        : worker?.customRole || {}
      let aux = {
        ...worker,
        mail: mail,
        rol: customRole,
      }
      const campos = {
        empresa: worker.organization ? worker.organization : "",
        movil: worker.mobile ? worker.mobile : "",
        nif: worker.nif ? worker.nif : "",
      }
      setLoading(true)
      await updateWorkerCampos(user.sub, aux, campos, [])
      await getWorkersByProject(user.sub, projectId)
      setLoading(false)
      setOpen(false)
    }
  }

  const handleDelete = async e => {
    e.preventDefault()
    setLoading(true)
    await deleteWorker(user.sub, worker.workerId)
    await getWorkersByProject(user.sub, projectId)
    setLoading(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
            {i18n.t("Editar Usuario")}
          </Typography>
          <IconButton onClick={() => setOpen(false)} sx={{ ml: 1 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ mt: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Typography sx={{ ml: 2, fontWeight: 600, color: "#414141" }}>
                {worker ? worker.fullName : ""}
              </Typography>
            </Box>
            <TextField
              name="mail"
              label={i18n.t("Email")}
              placeholder="Email"
              value={mail}
              onChange={handleChangeMail}
              inputRef={refEmail}
              onBlur={valida}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
              InputProps={{
                endAdornment: (
                  <>
                    <CheckCircleOutlineSharpIcon
                      style={{ width: "16px", color: "#3BA452" }}
                      ref={refEmailConfirm}
                      id="confirmNotVisible"
                    />
                    <ErrorOutlineSharpIcon
                      style={{ width: "16px", color: "#BF2929" }}
                      ref={refEmailError}
                      id="errorNotVisible"
                    />
                  </>
                ),
              }}
            />
            <TextField
              select
              label={i18n.t("Rol")}
              value={selectedRol}
              onChange={e => setSelectedRol(e.target.value)}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
            >
              {ROLE_OPTIONS.map(role => (
                <MenuItem key={role.value} value={role.value}>
                  {i18n.t(role.label)}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </DialogContent>
        {user && !user.freeTrialExpired && user["custom:role"] !== "WORKER" ? (
          <DialogActions sx={{ p: "16px 24px" }}>
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <>
                <Button
                  variant="contained"
                  color="branded"
                  onClick={handleUpdate}
                >
                  {i18n.t("Guardar")}
                </Button>
                <Button variant="outlined" color="error" onClick={handleDelete}>
                  {i18n.t("Eliminar")}
                </Button>
              </>
            )}
          </DialogActions>
        ) : null}
      </Dialog>
      <AddContact
        openAdd={openAdd}
        setOpenAdd={setOpenAdd}
        worker={worker}
        setCambiado={setCambiado}
      />
    </>
  )
}
UserEditModal.propTypes = {
  open: propTypes.bool.isRequired,
  setOpen: propTypes.func.isRequired,
  worker: propTypes.object.isRequired,
}
export default UserEditModal
